/*eslint-disable*/
import React, { Suspense, useEffect } from 'react';
import {
  Switch,
  Route,
  Redirect, useLocation
} from 'react-router-dom';
import Spinner from '@Src/commons/Spinner';
import { isLoggedIn, isNextPlatform } from '@Src/commons/Utils/authUtils';
import PrivateRoute from './PrivateRoute';
import PublicRoute from './PublicRoute';
import AppPrivateRouter from '@Src/containers/AppRouting/AppPrivateRouter';
import updateTitle from './UpdateTitle';
import InvoiceDetails from '@Src/pages/GrnAcceptance/InvoiceDetails';
import SessionsExpired from '@Src/components/Devices/SessionsExpired';

const PageAuthLogin = React.lazy(() => import('@Src/pages/PageAuthLogin'));
const PageAuthSignup = React.lazy(() => import('@Src/pages/PageAuthSignup'));
const PageEnquiry = React.lazy(() => import('@Src/pages/PageEnquiry'));
const ProductList = React.lazy(() => import('@Src/components/Enquiry/RmHomePage/ProductList'));
const SubmissionPage = React.lazy(() => import('@Src/components/Enquiry/Submittion/SubmittionPage'));
const LandingPage = React.lazy(()=> import('@Src/components/Enquiry/DynamicHome/LandingPage'));
const NewsHome = React.lazy(() => import('@Src/components/Enquiry/News/NewsHome'));
const DetailPage = React.lazy(() => import('@Src/components/Enquiry/RmHomePage/DetailPage'));
const PurchaseRequestConfirmedPage = React.lazy(() => import('@Src/pages/PurchaseRequestConfirmed'));
const PageForgotPassword = React.lazy(() =>
  import('@Src/pages/PageForgotPassword')
);
const PageResetPassword = React.lazy(() =>
  import('@Src/pages/PageResetPassword')
);
const PageInstaInvoice = React.lazy(() =>
  import('@Src/pages/PageInstaInvoice')
);
const PagePreScreenForFinPaas = React.lazy(() =>
  import('@Src/pages/UserPreScreenForFinPaaS')
);

const DeepLinkPage = React.lazy(() =>
  import('@Src/pages/DeeplinkTest/DeepLinkPage')
);

// const FinpaasApp = React.lazy(() => import('@Src/MicrofrontendApp/FinpaasApp'));
function AppRoutes() {
  const locacation = useLocation();
  useEffect(() => {
    const title = updateTitle();
    // Add event listeners to listen for URL changes
    window.addEventListener('popstate', updateTitle);
    // window.addEventListener('hashchange', updateTitle);
    // console.log("Page visited", locacation.pathname);

    // Clean up the event listeners when the component unmounts
    // clevertap.event.push("Page visited", {
    //   "page": locacation.pathname,
    //   "page title": title,
    // })
    return () => {
      window.removeEventListener('popstate', updateTitle);
      // window.removeEventListener('hashchange', updateTitle);
    };
  }, [locacation.pathname]);

  return (
    <Suspense fallback={<Spinner />}>
      <Switch>
        <Route path="/dl/*" component={DeepLinkPage} />
        <PublicRoute path="/app/create-invoice" component={PageInstaInvoice} />
        <PublicRoute path="/confirm-order/:purchaseRequestId" component={PurchaseRequestConfirmedPage} />
        <PublicRoute path="/app/invoice/:id" component={InvoiceDetails} />
        <PublicRoute
          path="/app/pre-screening"
          component={PagePreScreenForFinPaas}
        />
        <PrivateRoute path="/app" component={AppPrivateRouter} />
        <PublicRoute path="/auth/login" component={PageAuthLogin} />
        <PublicRoute path="/auth/sign-up" component={PageAuthSignup} />
        <Route exact path="/buy/news-listing" component={NewsHome} />
        <PublicRoute exact path="/buy/submit" component={SubmissionPage} />
        <PublicRoute
          path="/auth/forgot-password"
          component={PageForgotPassword}
        />
        <PublicRoute
          path="/auth/reset-password"
          component={PageResetPassword}
        />
        <PublicRoute path="/auth">
          <Redirect to="/auth/login" />
        </PublicRoute>
        <Route path="/sessions-expired">
          <SessionsExpired/>
        </Route>
        {/* {isNextPlatform() && (
          // <Route path="/finpaas">
          //   <FinpaasApp basePath={`/finpaas`} />
          // </Route>
          <></>
        )} */}
       
        <PublicRoute exact path="/buy" component={LandingPage} />

        <PublicRoute
          exact
          path="/buy/:material(aluminium|steel)"
          component={PageEnquiry}
        />

        <PublicRoute
          exact
          path="/buy/:material(aluminium|steel)/:skuId"
          component={DetailPage}
        />

        <PublicRoute
          exact
          path="/buy/listing/:material(aluminium|steel)"
          component={ProductList}
        />

        <Route path="/">
          {isLoggedIn() ? <Redirect to="/app" /> : <Redirect to="/auth" />}
        </Route>
      </Switch>
    </Suspense>
  );
}

export default AppRoutes;
